import * as _ from 'lodash';

export const merge = <T = any>(...args: object[]) => {
	return _.merge({}, ...args) as T;
};

export const mergeObjects = merge;

export default merge;
